var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('h2',[_vm._v("This page can't be found.")]),_c('div'),_c('br'),(_vm.previous)?_c('p',[_c('a',{attrs:{"href":_vm.previous.path}},[_vm._v("Return to previous page")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }